import styled from "styled-components";

export const AppFlexBody = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  background-color: #012030;
  height: 100vh;
`;
